
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"10","cy":"12","r":"2"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"12","cy":"4","r":"2"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"4","cy":"6","r":"2"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  